import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    maxHeight: '45vh',
  },

  table: {
    display: 'flex',
    margin: theme.spacing(5),
    maxHeight: '100%',
  },

  associationsTable: {
    margin: theme.spacing(5),

    '& tbody': {
      display: 'flex',
      justifyContent: 'space-between',

      '& tr': {
        width: '100%',
      },
    },
  },

  attributesTable: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(5),
  },

  verticalTable: {
    display: 'flex',
    flexDirection: 'column',

    '& tr': {
      width: '100%',
    },

    '& th': {
      fontWeight: '600',
      fontSize: '0.9rem',
      width: '100%',
    },

    '& th, & td': {
      display: 'flex',
      alignItems: 'center',
      border: `1px solid ${theme.palette.border.main}`,
      lineHeight: '1.5rem',
      width: '100%',
      height: '80px',
    },
  },

  horizontalTable: {
    display: 'flex',

    '& th': {
      fontWeight: '600',
      fontSize: '0.9rem',
      width: '100%',
    },

    '& tr': {
      width: '100%',
    },

    '& th, & td': {
      display: 'flex',
      alignItems: 'center',
      border: `1px solid ${theme.palette.border.main}`,
      lineHeight: '1.5rem',
      width: '100%',
      height: '80px',
    },
  },
}));

export default useStyles;
